export const NOT_AVAILABLE = 0;
export const FULL_AVAILABLE = 1;
export const AVAILABLE_WHILE_CHARGING = 2;
